module.exports = __webpack_public_path__ + "img/rule_of_nines.15893eb2.png";